import { render, staticRenderFns } from "./MigrationDialog.vue?vue&type=template&id=aa385d3c&scoped=true"
import script from "./MigrationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MigrationDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MigrationDialog.vue?vue&type=style&index=0&id=aa385d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa385d3c",
  null
  
)

export default component.exports